// FiveTemplates.tsx
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { getStudentImage } from '../../../common/styles/Images';
import { axiosClient } from '../../../library/Service/axiosClient';
const imgcloudcomputing = `${process.env.REACT_APP_IMAGE_BASEPATH}/cloud-computing.svg`;
const imglogo = `${process.env.REACT_APP_IMAGE_BASEPATH}/001acd5e_logo.jpg`;

type FormState = {
    name: string;
    programName: string;
    passOutYear: string;

    ugCollege: string;
    ugDepartment: string;

    pgCollege: string;
    pgDepartment: string;

    jobCompany: string;
    jobDesignation: string;

    achievement: string;

    profilePictureFilePath: string; // can hold base64 or URL
    jobLogoBase64: string;
};

const FiveTemplates: React.FC = () => {
    const [schoolImage, setSchoolImage] = useState<string | null>(null);
    const [primaryColor, setPrimaryColor] = useState('#0064A7');
    const [secondaryColor, setSecondaryColor] = useState('#0064A7');
    const [poweredByBase64, setPoweredByBase64] = useState<string>('');
    const [selectedDataSet, setSelectedDataSet] = useState<string>('JoinedUGCollege');
    const divRef = useRef<HTMLDivElement>(null);
    const previewRef = useRef<Window | null>(null);

    const jwtToken = localStorage.getItem('user-jwt-token');

    const [form, setForm] = useState<FormState>({
        name: '',
        programName: '',
        passOutYear: '',
        ugCollege: '',
        ugDepartment: '',
        pgCollege: '',
        pgDepartment: '',
        jobCompany: '',
        jobDesignation: '',
        achievement: '',
        profilePictureFilePath: '',
        jobLogoBase64: '',
    });

    const updateForm = (key: keyof FormState) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const val = e.target.value;
        setForm((p) => ({ ...p, [key]: val }));
    };

    const [errors] = useState({
        user: '',
        username: '',
        schoolname: '',
        programname: '',
        passout: '',
        ugcollege: '',
        ugcourse: '',
        companyname: '',
        currentdesignation: '',
        pgcollege: '',
        pgcourse: '',
        currentlocation: '',
        achievement: '',
        dataSet: '',
        image: '',
    });

    useEffect(() => {
        const fetchSchoolLogo = async () => {
            try {
                const user = sessionStorage.getItem('user');
                const primaryInstitute = user ? JSON.parse(user).primaryInstitute : 0;

                const response = await axios.post(`${process.env.REACT_APP_BROADCAST_SERVER}/pre-signup/get-institute-name`, {
                    id: primaryInstitute,
                });

                if (response.data?.success && response.data.result?.[0]?.logo) {
                    setSchoolImage(response.data.result[0].logo);
                } else {
                    console.warn('No school logo returned from the API. Using fallback image.');
                }
            } catch (error) {
                console.error('Error fetching school logo:', error);
            }
        };

        fetchSchoolLogo();
    }, []);

    const normalizeDataUrl = (dataUrlOrBase64: string) => {
        if (!dataUrlOrBase64) return '';

        if (dataUrlOrBase64.startsWith('data:image')) {
            const parts = dataUrlOrBase64.split(',');
            if (parts.length < 2) return dataUrlOrBase64;

            const base64 = parts.slice(1).join(',').trim();
            if (base64.startsWith('PHN2Zy')) return `data:image/svg+xml;base64,${base64}`;

            return dataUrlOrBase64;
        }
        const base64 = dataUrlOrBase64.trim();
        if (base64.startsWith('PHN2Zy')) return `data:image/svg+xml;base64,${base64}`;

        return `data:image/png;base64,${base64}`;
    };

    useEffect(() => {
        const loadPoweredByLogo = async () => {
            try {
                const logoUrl = 'https://www.univariety.xyz/prototype/school_dashboard/images/univariety-white-logo.svg';

                const res = await axiosClient().post(`${process.env.REACT_APP_BROADCAST_SERVER}/pre-signup/get-base64-path`, {
                    image: logoUrl,
                });

                if (res.data?.success && res.data?.result) {
                    setPoweredByBase64(normalizeDataUrl(res.data.result));
                } else {
                    setPoweredByBase64('');
                }
            } catch (error) {
                console.error('Failed to load powered-by logo', error);
                setPoweredByBase64('');
            }
        };

        loadPoweredByLogo();
    }, []);

    useEffect(() => {
        const userJwtToken = sessionStorage.getItem('user-jwt-token');
        if (!userJwtToken) window.location.href = '/404';
    }, []);

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedDataSet(event.target.value);
    };

    const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const apiUrl = `${process.env.REACT_APP_COMMON_API}/upload/image`;
        const fd = new FormData();

        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            fd.append('image', file);

            try {
                // Upload image to your server and get the image URL
                const response = await axiosClient().post(apiUrl, fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

                const newImageUrl = response.data.link;

                // Convert the uploaded image to Base64
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64Image = reader.result as string;

                    setForm((prev) => ({ ...prev, profilePictureFilePath: base64Image }));
                };

                reader.readAsDataURL(file); // This will trigger the onloadend callback
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };
      // Image upload handler
    const handleJobLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];

            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Data = reader.result as string;
                setForm((prev) => ({
                    ...prev,
                    jobLogoBase64: base64Data, // Store the uploaded image as base64
                }));
            };
            reader.readAsDataURL(file); // Convert file to base64
        }
    };

    function dataURLtoBlob(dataUrl: string): Blob {
        const [metadata, base64] = dataUrl.split(',');
        const byteString = atob(base64);
        const mimeString = metadata.split(':')[1].split(';')[0];

        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uintArray[i] = byteString.charCodeAt(i);
        }

        return new Blob([uintArray], { type: mimeString });
    }

    const handleShareOnSocialMedia = async () => {
        if (!divRef.current) {
            console.error('Element not found!');
            return;
        }

        const { default: html2canvas } = await import('html2canvas');
        const scaleFactor = 3; // Increase scale factor for better quality
        const canvas = await html2canvas(divRef.current, {
            backgroundColor: secondaryColor,
            scale: scaleFactor,
            useCORS: true,
            allowTaint: false,
        });

        const dataUrl = canvas.toDataURL('image/png', 1.0); // Use maximum quality
        const imageBlob = dataURLtoBlob(dataUrl); // Convert base64 to Blob

        // Step 2: Upload the image to S3 via your API
        const apiUrl = `${process.env.REACT_APP_BROADCAST_SERVER}/upload/get-attached`;
        const formData = new FormData();
        formData.append('pdf_doc', imageBlob, 'spotlight_image.png');

        try {
            // Include the token in the headers for authentication
            const response = await axios.post(apiUrl, formData, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`, // Include the token in the Authorization header
                },
            });

            const link = response.data.link;

            if (response.data.success) {
                // Step 3: Store the S3 URL in sessionStorage
                sessionStorage.setItem('spotlight_post_image_url', link);

                // Redirect to the "get-image" page
                window.location.href = '/socialmedia/socialpost?social_post=1'; // Adjust this to your route for displaying the image
            } else {
                alert('Error uploading image to S3');
            }
        } catch (error) {
            console.error('Error uploading image:', error);
            alert('Failed to upload image.');
        }
    };

    const handlePreview = async () => {
        if (!divRef.current) {
            console.error('Element not found!');
            return;
        }
        const computedStyle = window.getComputedStyle(divRef.current);
        const originalBgColor = computedStyle.backgroundColor;

        divRef.current.style.backgroundColor = originalBgColor; // Retain the original background color

        const { default: html2canvas } = await import('html2canvas');
        const scaleFactor = 3; // Increase scale factor for better quality
        const canvas = await html2canvas(divRef.current, {
            backgroundColor: null, // Set null to retain actual background
            scale: scaleFactor, // Increase scale factor
            useCORS: true, // Enable CORS for external images
            allowTaint: false, // Disallow tainting the canvas
        });

        if (!previewRef.current || previewRef.current.closed) {
            const screenWidth = window.screen.width;
            const screenHeight = window.screen.height;
            const popupWidth = 400; // Set desired width
            const popupHeight = 400; // Set desired height
            const left = (screenWidth - popupWidth) / 2;
            const top = (screenHeight - popupHeight) / 2;
            previewRef.current = window.open('', 'Preview', `width=${popupWidth},height=${popupHeight},top=${top},left=${left}`);
        }

        if (previewRef.current) {
            previewRef.current.document.body.innerHTML = '';
            previewRef.current.document.write(
                '<html><head><title>Preview</title></head><body style="margin: 0; display: flex; align-items: center; justify-content: center; background: #ffffff;"></body></html>'
            );
            const img = document.createElement('img');
            img.src = canvas.toDataURL('image/png', 1.0); // Use maximum quality
            img.style.width = '100%';
            img.style.height = 'auto';
            previewRef.current.document.body.appendChild(img);
        }

        // Reset the background color after capturing (optional)
        divRef.current.style.backgroundColor = originalBgColor;
    };
    const handleDownload = async () => {
        if (!divRef.current) {
            console.error('Element not found!');
            return;
        }

        const images = Array.from(divRef.current.querySelectorAll('img')) as HTMLImageElement[];

        try {
            await Promise.all(
                images.map((img) => {
                    return new Promise((resolve, reject) => {
                        if (img.complete && img.naturalWidth > 0) {
                            resolve(true);
                        } else {
                            img.onload = () => resolve(true);
                            img.onerror = () => reject(false);
                        }
                    });
                })
            );

            const { default: html2canvas } = await import('html2canvas');
            const scaleFactor = 2; // Increase scale factor for better quality (400px / 400px = 2.7, so 3 is safe)
            const canvas = await html2canvas(divRef.current, {
                backgroundColor: secondaryColor,
                scale: scaleFactor, // Increase scale factor
                useCORS: true,
                allowTaint: false,
            });

            const scaledCanvas = document.createElement('canvas');
            scaledCanvas.width = 400; // Set desired width
            scaledCanvas.height = 400; // Set desired height
            const scaledContext = scaledCanvas.getContext('2d');

            if (scaledContext) {
                scaledContext.fillStyle = '#ffffff';
                scaledContext.fillRect(0, 0, 400, 400);
                scaledContext.drawImage(canvas, 0, 0, 400, 400);

                const dataUrl = scaledCanvas.toDataURL('image/png', 1.0); // Use maximum quality
                const link = document.createElement('a');
                link.href = dataUrl;
                link.download = 'spotlights-pic.jpg'; // Updated file name
                link.click();
            }
        } catch (error) {
            console.error('Error generating image:', error);
        }
    };
    return (
        <div className="main flex-1">
            <section className="alumni_directory_details">
                <div className="max-1140 mx-auto pt-5">
                    <div className="d-flex justify-content-between align-items-center pb-3">
                        <h3 data-aos="fade-left" data-aos-delay="600" className="font-30 font-600 mb-0 block-title position-relative">
                            Create New Image Template <i className="icon-right-arrow font-16 position-relative me-1"></i>
                            <span>Configure</span>
                        </h3>
                    </div>
                </div>

                <div className="max-1140 pb-5 overflow-hidden mx-auto">
                    <div className="row g-4">
                        <div className="col-sm-12">
                            <div className="bg-gray-F2F4F7 border-radius-6 p-3 p-sm-4 px-md-5 text-center font-24 font-500">
                                Leaders of the Future 3
                            </div>
                        </div>

                        <div className="col-sm-12">
                            <div className="row g-2 justify-content-between pb-2">
                                <div className="col-auto font-20 font-500">
                                    Category <span className="font-18 font-400">Success Stories</span>
                                </div>
                                <div className="col-auto font-20 font-500">
                                    Size <span className="font-18 font-400">Instagram Post - 1080 x 1080 px</span>
                                </div>
                            </div>

                            <div className="bg-gray-F2F4F7 border-radius-6 p-3 p-sm-4">
                                <div className="row g-4">
                                    {/* LEFT COLUMN – TEMPLATE PREVIEW */}
                                    <div className="col-md-6">
                                        <div className="w-100 h-100">
                                            <div className="bg-white border-radius-6 p-4 w-100 border h-100 d-flex justify-content-center align-items-start" >
                                                <div className="position-sticky top-20">
                                                    <div className="xscroll">
                                                        <div className="mx-auto overflow-auto">
                                                            <div
                                                                className="leaders-poster-templete-4 position-relative overflow-hidden ratio-484"
                                                                style={{ backgroundColor: primaryColor }}   ref={divRef}
                                                        >
                                                                <div className="college-logo">
                                                                    <img
                                                                        src={
                                                                            schoolImage ||
                                                                            'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/vishwashanti-logo.png'
                                                                        }
                                                                        className="img-fluid"
                                                                        alt="College Logo"
                                                                    />
                                                                </div>

                                                                <div className="background-color" style={{ backgroundColor: '#953795' }} />

                                                                <img
                                                                    src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/new-template-frame-2.png"
                                                                    className="img-fluid"
                                                                    alt="Template Frame"
                                                                />

                                                                <div className="leaders-poster-title position-absolute text-center w-100 d-flex justify-content-center">
                                                                    <div>Leaders of the Future</div>
                                                                </div>

                                                                <div className="leaders-poster-templete-4-alumni">
                                                                    <img
                                                                        src={
                                                                            form.profilePictureFilePath
                                                                                ? getStudentImage({
                                                                                      profilePictureFilePath: form.profilePictureFilePath,
                                                                                      genderCode: '',
                                                                                  })
                                                                                : 'https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/profile_pic.png'
                                                                        }
                                                                        alt="Profile pic"
                                                                        width="90"
                                                                    />
                                                                </div>

                                                                <div className="leaders-poster-alumni-detail">
                                                                    <div
                                                                        className="leaders-poster-alumni-name"
                                                                        style={{ color: secondaryColor }}>
                                                                        {' '}
                                                                        {form.name || 'Alumni Name'}
                                                                    </div>

                                                                    <div className="leaders-poster-alumni-batch-school">
                                                                        {form.passOutYear ? `| Batch ${form.passOutYear}` : '2023'} | <br />
                                                                        {form.programName || 'Program'}
                                                                        
                                                                    </div>

                                                                    <i className="line" />
                                                                </div>

                                                                <div className="job-list">
                                                                     <div className="logo-job-list">
                                                                    <img
                                                                        src={form.jobLogoBase64 || imglogo} // Show uploaded image or fallback to default logo
                                                                        alt="Cyient Logo"
                                                                        id="jobLogoUpload"
                                                                        style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain' }}
                                                                    />

                                                                    
                                                                </div>
                                                                
                                                                    <div className="job-list-name">
                                                                        {selectedDataSet === 'JoinedUGCollege' &&
                                                                        (form.ugCollege || form.ugDepartment)
                                                                            ? `${form.ugDepartment ? `${form.ugDepartment} @ ` : ''}${
                                                                                  form.ugCollege
                                                                              }`
                                                                            : selectedDataSet === 'JoinedPGCollege' &&
                                                                              (form.pgCollege || form.pgDepartment)
                                                                            ? `${form.pgDepartment ? `${form.pgDepartment} @ ` : ''}${
                                                                                  form.pgCollege
                                                                              }`
                                                                            : selectedDataSet === 'CurrentCompany' &&
                                                                              (form.jobCompany || form.jobDesignation)
                                                                            ? `${form.jobDesignation ? `${form.jobDesignation} @ ` : ''}${
                                                                                  form.jobCompany
                                                                              }`
                                                                            : 'Details'}
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    className="footer-text position-absolute w-100 bottom-0"
                                                                    style={{ backgroundColor: '#F67D36', color: '#fff' }}>
                                                                    <div className="left-text">
                                                                        <h6 className="d-block font-600 mb-0">EXPERTISE</h6>
                                                                        {form.achievement || 'Enter achievement here'}
                                                                    </div>

                                                                    <div className="powerby">
                                                                        <span className="text-white">Powered By </span>
                                                                        <img
                                                                            src={
                                                                                poweredByBase64 ||
                                                                                'https://www.univariety.xyz/prototype/school_dashboard/images/univariety-white-logo.svg'
                                                                            }
                                                                            alt="Powered by Univariety"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* RIGHT COLUMN – FORM */}
                                    <div className="col-md-6">
                                        <div className="bg-white border-radius-6 p-4 h-100">
                                            <div className="col-md-12">
                                                <div className="row g-3 align-items-center mb-2">
                                                    <div className="col-12">
                                                        <input
                                                            type="text"
                                                            onChange={updateForm('name')}
                                                            value={form.name}
                                                            className="form-control"
                                                            placeholder="Enter Alumni Name"
                                                            maxLength={38}
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <input
                                                            type="text"
                                                            onChange={updateForm('programName')}
                                                            value={form.programName}
                                                            className="form-control"
                                                            placeholder="Enter Alumni Program"
                                                            maxLength={48}
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <input
                                                            type="text"
                                                            onChange={updateForm('passOutYear')}
                                                            value={form.passOutYear}
                                                            className="form-control"
                                                            placeholder="Enter Alumni Batch Year"
                                                            maxLength={11}
                                                        />
                                                    </div>

                                                    {/* Achievement FIELD */}
                                                    <div className="col-12">
                                                        <label className="form-check-label font-16 font-500 mb-1">Achievement</label>
                                                        <input
                                                            type="text"
                                                            onChange={updateForm('achievement')}
                                                            value={form.achievement}
                                                            className="form-control"
                                                            placeholder="Enter Achievement"
                                                            maxLength={120}
                                                        />
                                                        {errors.achievement && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>{errors.achievement}</div>
                                                        )}
                                                    </div>

                                                    {/* dataset radios and inputs (same as before) */}
                                                    <div className="col-12">
                                                        <input
                                                            type="radio"
                                                            name="DataSet"
                                                            id="JoinedUGCollege"
                                                            value="JoinedUGCollege"
                                                            onChange={handleRadioChange}
                                                            className="form-check-input custom-border-84-20 m-0 college-type"
                                                            checked={selectedDataSet === 'JoinedUGCollege'}
                                                        />
                                                        <label htmlFor="JoinedUGCollege" className="form-check-label font-16 font-500 ms-2">
                                                            Joined UG
                                                        </label>

                                                        <div className="row g-2 mt-0 college-type-option">
                                                            <div className="col-sm-6 col-md-12 col-lg-6">
                                                                <label className="form-check-label font-16 font-500 mb-1">
                                                                    Joined UG College
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    onChange={updateForm('ugCollege')}
                                                                    value={form.ugCollege}
                                                                    className="form-control"
                                                                    placeholder="Enter College Name"
                                                                    maxLength={50}
                                                                />
                                                            </div>

                                                            <div className="col-sm-6 col-md-12 col-lg-6">
                                                                <label className="form-check-label font-16 font-500 mb-1">
                                                                    Joined UG Course
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    onChange={updateForm('ugDepartment')}
                                                                    value={form.ugDepartment}
                                                                    className="form-control"
                                                                    placeholder="Enter Course Name"
                                                                    maxLength={25}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <input
                                                            type="radio"
                                                            name="DataSet"
                                                            id="JoinedPGCollege"
                                                            value="JoinedPGCollege"
                                                            onChange={handleRadioChange}
                                                            className="form-check-input custom-border-84-20 m-0 college-type"
                                                            checked={selectedDataSet === 'JoinedPGCollege'}
                                                        />
                                                        <label htmlFor="JoinedPGCollege" className="form-check-label font-16 font-500 ms-2">
                                                            Joined PG
                                                        </label>

                                                        <div className="row g-2 mt-0 college-type-option">
                                                            <div className="col-sm-6 col-md-12 col-lg-6">
                                                                <label className="form-check-label font-16 font-500 mb-1">
                                                                    Joined PG College
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    onChange={updateForm('pgCollege')}
                                                                    value={form.pgCollege}
                                                                    className="form-control"
                                                                    placeholder="Enter College Name"
                                                                    maxLength={50}
                                                                />
                                                            </div>

                                                            <div className="col-sm-6 col-md-12 col-lg-6">
                                                                <label className="form-check-label font-16 font-500 mb-1">
                                                                    Joined PG Course
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    onChange={updateForm('pgDepartment')}
                                                                    value={form.pgDepartment}
                                                                    className="form-control"
                                                                    placeholder="Enter Course Name"
                                                                    maxLength={25}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <input
                                                            type="radio"
                                                            name="DataSet"
                                                            id="CurrentCompany"
                                                            value="CurrentCompany"
                                                            onChange={handleRadioChange}
                                                            className="form-check-input custom-border-84-20 m-0 college-type"
                                                            checked={selectedDataSet === 'CurrentCompany'}
                                                        />
                                                        <label htmlFor="CurrentCompany" className="form-check-label font-16 font-500 ms-2">
                                                            Current Company
                                                        </label>

                                                        <div className="row g-2 mt-0 college-type-option">
                                                            <div className="col-sm-6 col-md-12 col-lg-6">
                                                                <label className="form-check-label font-16 font-500 mb-1">
                                                                    Company Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    onChange={updateForm('jobCompany')}
                                                                    value={form.jobCompany}
                                                                    className="form-control"
                                                                    placeholder="Enter Company Name"
                                                                    maxLength={50}
                                                                />
                                                            </div>

                                                            <div className="col-sm-6 col-md-12 col-lg-6">
                                                                <label className="form-check-label font-16 font-500 mb-1">
                                                                    Current Designation
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    onChange={updateForm('jobDesignation')}
                                                                    value={form.jobDesignation}
                                                                    className="form-control"
                                                                    placeholder="Enter Designation"
                                                                    maxLength={25}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <hr />
                                                    </div>

                                                    <div className="col-md-12">
                                                        <label
                                                            className="form-label m-0 mb-1 font-16 font-500 w-100 mb-2"
                                                            htmlFor="cloud-computing">
                                                            Upload Display Image
                                                        </label>

                                                        <div className="upload_section">
                                                            <input
                                                                type="file"
                                                                id="cloud-computing"
                                                                onChange={handleImageUpload}
                                                                className=""
                                                                accept="image/*"
                                                            />
                                                            <div className="row g-2 align-items-center justify-content-center">
                                                                <div className="col-sm d-flex align-items-center justify-content-center">
                                                                    <div className="cloud-wrap px-3 px-sm-5 mx-auto">
                                                                        <div className="cloud-img">
                                                                            <img src={imgcloudcomputing} alt="" />
                                                                        </div>
                                                                        <div className="cloud-text">
                                                                            <a
                                                                                href="#"
                                                                                className="text-sky-blue"
                                                                                onClick={(e) => e.preventDefault()}>
                                                                                Browse
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <span className="text-end font-14 d-block text-dark-blue opacity-7 mt-1">
                                                            Only png, jpg, jpeg files. Best resolution 400px x 400px
                                                        </span>
                                                    </div>

                                                    <div className="col-md-12">
                                                
                                                        <label htmlFor="jobLogoUploadInput" className="form-label m-0 mb-1 font-16 font-500 w-100 mb-2 cursor-pointer">
                                                                   Upload Logo Image
                                                                </label>

                                                        <div className="upload_section">
                                                            <input
                                                                type="file"
                                                                id="jobLogoUploadInput"
                                                                onChange={handleJobLogoUpload}
                                                                className=""
                                                                accept="image/*"
                                                            />
                                                         
                                                            <div className="row g-2 align-items-center justify-content-center">
                                                                <div className="col-sm d-flex align-items-center justify-content-center">
                                                                    <div className="cloud-wrap px-3 px-sm-5 mx-auto">
                                                                        <div className="cloud-img">
                                                                            <img src={imgcloudcomputing} alt="" />
                                                                        </div>
                                                                        <div className="cloud-text">
                                                                            <a
                                                                                href="#"
                                                                                className="text-sky-blue"
                                                                                onClick={(e) => e.preventDefault()}>
                                                                                Browse
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <span className="text-end font-14 d-block text-dark-blue opacity-7 mt-1">
                                                            Only png, jpg, jpeg files. Best resolution 400px x 400px
                                                        </span>
                                                    </div>

                                                
                                                                

                                                 
                                                        <div className="col-md-6">
                                                            <label className="form-label m-0 mb-1 font-16 font-500">
                                                                Primary Color Shade
                                                            </label>
                                                            <input
                                                                type="color"
                                                                value={primaryColor}
                                                                onChange={(e) => setPrimaryColor(e.target.value)}
                                                                className="form-control form-search radius-25"
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label className="form-label m-0 mb-1 font-16 font-500">
                                                                Secondary Color Shade
                                                            </label>
                                                            <input
                                                                type="color"
                                                                value={secondaryColor}
                                                                onChange={(e) => setSecondaryColor(e.target.value)}
                                                                className="form-control form-search radius-25"
                                                            />
                                                        </div>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /RIGHT */}
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-12">
                            <div className="action_btns mt-0 max-100per">
                                <button type="button" className="nextbtn my-2 my-sm-0 mx-2 px-5" onClick={handlePreview}>
                                    Preview
                                </button>
                                <button type="button" className="btn btn-green my-2 my-sm-0 mx-2 height-45 px-5">
                                    <span className="px-3" onClick={handleDownload}>
                                        Save
                                    </span>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-border-gray my-2 my-sm-0 mx-3 height-45"
                                    onClick={handleShareOnSocialMedia}>
                                    <span className="px-3">Share on Social Media</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FiveTemplates;
